<body>
  <!-- Header -->
  <!-- <header class="kemis-header">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-auto">
          <img src="../../../assets/img/logo1.png" alt="KEMIS - Kenya Education Management Information System"
            class="kemis-logo" />
        </div>
      </div>
    </div>
  </header> -->
  <div class="container-fluid topbg">
    <div class="row align-items-center flex-wrap text-white px-3 px-md-4">
      <!-- Left: Contact Info -->
      <div
        class="col-6 col-md-6 mb-2 mb-md-0 d-flex flex-column flex-sm-row align-items-start align-items-sm-center gap-3">
        <div class="d-md-block d-none d-sm-none"><i class="bi bi-whatsapp"></i> +91 9643362320</div>
        <div class="d-md-block d-none d-sm-none"><i class="bi bi-envelope"></i> contact@bharatboudhiks.com</div>
      </div>

      <!-- Right: Search, Login, Social -->
      <div
        class="col-6 col-md-6 d-flex justify-content-start justify-content-md-end align-items-center flex-wrap gap-3">
        <!-- <div class="search-btn d-none d-lg-block">
          <i class="bi bi-search"></i>
        </div> -->

        <button class="login-btn" (click)="GoToLogin()">Login</button>

        <div class="social-icons d-flex justify-content-between gap-2">
          <a href="#"><i class="bi bi-facebook"></i></a>
          <!-- <a href="#"><i class="bi bi-twitter-x"></i></a> -->
          <a href="#"><i class="bi bi-youtube"></i></a>
          <a href="#"><i class="bi bi-linkedin"></i></a>
        </div>
      </div>
    </div>
  </div>

  <nav class="navbar navbar-expand-lg py-2" style="background-color: #fff !important;">
    <div class="container-fluid px-4 d-flex align-items-center justify-content-between flex-wrap">
      <!-- Left Logo -->
      <!-- <a class="navbar-brand d-flex align-items-center order-2 order-lg-0" href="#">
        <img src="../../../assets/images/landing_imgs/Ministry-of-Kenya-Logo.png" alt="Left Logo"
          class="logo-img me-xl-2" />
      </a> -->

      <!-- Mobile Toggle Button -->
      <!-- <button class="navbar-toggler p-2" type="button" data-bs-toggle="collapse" data-bs-target="#mainNavbar"
        aria-controls="mainNavbar" aria-expanded="false" aria-label="Toggle navigation">
        <i class="bi bi-list"></i>
      </button> -->

      <!-- Nav Items -->
      <div class="collapse navbar-collapse justify-content-center" id="mainNavbar">
        <!-- <ul class="navbar-nav mx-auto justify-content-center w-100">
          <li class="nav-item">
            <a class="nav-link nav-home" href="#">Home</a>
          </li>
          <li class="nav-item">
            <a class="nav-link nav-about" href="#about-kemis">About KEMIS</a>
          </li>
          <li class="nav-item">
            <a class="nav-link nav-modules" href="#system-module">System Modules</a>
          </li> -->
        <!-- <li class="nav-item">
            <a class="nav-link nav-edulocker" href="#">EduLocker</a>
          </li> -->
        <!-- <li class="nav-item">
            <a class="nav-link nav-stakeholder" href="#">Stakeholder Portals</a>
          </li> -->
        <!-- <li class="nav-item">
            <a class="nav-link nav-resources">Resources</a>
          </li>
          <li class="nav-item">
            <a class="nav-link text-dark" href="#support">Support</a>
          </li>
        </ul> -->
      </div>

      <!-- Right Logo -->
      <div class="d-lg-block d-none order--2">
        <img src="../../../assets/img/bharat-logo.jpg" alt="Right Logo" class="logo-img" />
      </div>
    </div>
  </nav>
  <!-- Main Content -->
  <main class="kemis-main">
    <div class="container">
      <!-- Progress Indicator -->
      <div class="progress-section">
        <!-- Progress Steps -->

      </div>

      <!-- Step 2: Institution Details -->

      <div class="step-content" *ngIf="currentStep === 1" id="step-2-content">
        <div class="content-wrapper">
          <div class="kemis-card">
            <div class="card-header">
              <h2 class="card-title">Institution Details</h2>
              <p class="card-description">
                Provide your institution information to complete registration
              </p>
            </div>
            <div class="card-body">
              <div id="institution-form" [formGroup]="instituteRegForm">
                <!-- Basic Institution Details -->
                <div>


                  <div class="form-section">
                    <h4 class="section-title">
                      <i class="fas fa-building section-icon"></i>
                      Institution Details
                    </h4>

                    <div class="form-grid">

                      <div class="form-group">
                        <label for="institutionName" class="form-label">Name of Institution
                          <sup class="text-danger">*</sup></label>
                        <input type="text" class="form-control kemis-input" id="institutionName" name="institutionName"
                          placeholder="Enter institution name" formControlName="TNT_NAME"
                          (keypress)="keyPressValdsn($event, 'AN')" />
                        <!-- (keypress)="keyPressValdsn($event, 'AN')" (change)="checkInstitutionName($event)" /> -->
                        <!-- <div class="invalid-feedback">
                          Please provide institution name.
                        </div> -->
                        <!-- <div class="text-danger" *ngIf="(fc.TNT_NAME.touched || submitted) && fc.TNT_NAME.invalid"> -->
                        <div class="text-danger" *ngIf="(submitted) && fc.TNT_NAME.invalid">
                          <small *ngIf="fc.TNT_NAME.errors?.['required']">Please Provide Institution Name.</small>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="institutionName" class="form-label">Affiliation/University
                          <sup class="text-danger">*</sup></label>
                        <input type="text" class="form-control kemis-input" id="affiliationUniversity"
                          name="affiliationUniversity" placeholder="Enter affiliation/university name"
                          formControlName="affiliation_University" (keypress)="keyPressValdsn($event, 'AN')" />
                        <div class="text-danger" *ngIf="(submitted) && fc.affiliation_University.invalid">
                          <small *ngIf="fc.affiliation_University.errors?.['required']">Please Provide
                            Affiliation/University.</small>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="institutionAddress" class="form-label">Address<sup
                            class="text-danger">*</sup></label>
                        <!-- pattern="[0-9]*" -->
                        <input type="text" formControlName="address" class="form-control kemis-input"
                          placeholder="e.g. 1-/2/3" />
                        <div class="text-danger" *ngIf="(submitted) && fc.address.invalid">
                          <small *ngIf="fc.address.errors?.['required']">Please Provide The Address.</small>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="state" class="form-label">State <sup class="text-danger">*</sup></label>
                        <select class="form-control kemis-input" id="state" name="state"
                          formControlName="TNT_CONCURRENT_AVSESSIONS">
                          <option value="" disabled selected hidden>Select</option>
                          <option *ngFor="let item of states" [value]="item.state_id">
                            {{ item.state_name }}
                          </option>
                        </select>
                        <div class="text-danger" *ngIf="(submitted) && fc.TNT_CONCURRENT_AVSESSIONS.invalid-feedback">
                          <small *ngIf="fc.TNT_CONCURRENT_AVSESSIONS.errors?.['required']">Please Select State.</small>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="institutionName" class="form-label">Name
                          <sup class="text-danger">*</sup></label>
                        <input type="text" class="form-control kemis-input" id="institutionName" name="institutionName"
                          placeholder="Enter name" formControlName="candidate_name" />
                        <div class="text-danger" *ngIf="(submitted) && fc.candidate_name.invalid">
                          <small *ngIf="fc.candidate_name.errors?.['required']">Please Provide name.</small>
                        </div>
                      </div>

                      <div class="form-group">

                        <label for="contactEmail" class="form-label">
                          Email
                          <sup class="text-danger">*</sup>
                        </label>

                        <div class="d-flex gap-2">

                          <input type="email" class="form-control kemis-input" id="contactEmail"
                            placeholder="Enter email address" formControlName="email" />

                          <button type="button" class="btn otp-btn" (click)="sendOtp('email')"
                            [disabled]="emailVerified">
                            {{ emailVerified ? 'Verified' : 'Send OTP' }}
                          </button>

                        </div>

                        <div class="mt-2" *ngIf="emailOtpSent && !emailVerified">

                          <div class="d-flex gap-2">

                            <input type="text" class="form-control" placeholder="Enter Email OTP" [(ngModel)]="emailOtp"
                              [ngModelOptions]="{standalone: true}" />

                            <button type="button" class="btn btn-success" (click)="verifyOtp('email')">
                              Verify
                            </button>

                          </div>

                        </div>

                        <small class="text-success" *ngIf="emailVerified">
                          Email verified successfully
                        </small>

                      </div>

                      <div class="form-group">
                        <label for="contactPhone" class="form-label">
                          Phone Number
                          <sup class="text-danger">*</sup></label>
                        <div class="d-flex gap-2">
                          <select class="form-select small-width dropdown-sm" [(ngModel)]="countryCode"
                            [ngModelOptions]="{standalone: true}" disabled>
                            <option *ngFor="let item of country" [value]="item.COUNTRY_ID">{{
                              item.COUNTRY_CONNECTING_CODE }}</option>
                          </select>

                          <input type="tel" class="form-control kemis-input" id="contactPhone" name="contactPhone"
                            placeholder="Phone Number" formControlName="mobileno" inputmode="numeric" maxlength="10"
                            (input)="onMobileInput($event)" />

                          <!-- <input type="tel" class="form-control kemis-input" id="contactPhone" name="contactPhone"
                            placeholder="Phone Number" formControlName="mobileno" inputmode="numeric" maxlength="10"
                            (input)="onMobileInput($event)" [disabled]="mobileVerified" />
                          <button type="button" class="btn otp-btn" (click)="sendOtp('mobile')"
                            [disabled]="mobileVerified">
                            {{ mobileVerified ? 'Verified' : 'Send OTP' }}
                          </button> -->
                        </div>
                        <div class="mt-2" *ngIf="mobileOtpSent && !mobileVerified">

                          <div class="d-flex gap-2">

                            <input type="text" class="form-control" placeholder="Enter Mobile OTP"
                              [(ngModel)]="mobileOtp" [ngModelOptions]="{standalone: true}" />

                            <button type="button" class="btn btn-success" (click)="verifyOtp('mobile')">
                              Verify
                            </button>

                          </div>

                        </div>

                        <small class="text-success" *ngIf="mobileVerified">
                          Mobile verified successfully
                        </small>
                        <div class="text-danger" *ngIf="(submitted) && fc.mobileno.invalid">
                          <small *ngIf="fc.mobileno.errors?.['required']">{{
                            "Mobile Number"}}
                            is required.</small>
                          <small *ngIf="fc.mobileno.errors?.['pattern']">{{ "Mobile Number"
                            }}
                            must be 10 digits.</small>
                          <small *ngIf="fc.mobileno.errors?.['minlength']">Please enter 10 digits minimum.</small>
                        </div>
                      </div>

                    </div>
                  </div>
                  <!-- Coordinates Section -->
                  <div class="form-section d-none">
                    <h4 class="section-title">
                      <i class="fas fa-map-marker-alt section-icon"></i>
                      Co-ordinates
                    </h4>
                    <p class="text-danger mb-3" style="font-size: 11px !important">
                      Ensure the co-ordinates are captured while at the
                      flag-post position of the institution or search for your
                      school location through the map for the co-ordinates to be
                      populated
                    </p>

                    <!-- <div class="form-group">
                      <label for="latitude" class="form-label">Latitude <sup class="text-danger">*</sup></label>
                      <input type="number" class="form-control kemis-input" id="latitude" name="latitude"
                        placeholder="Enter latitude" step="any" formControlName="latitude" />
                    </div>
                    <div class="form-group">
                      <label for="longitude" class="form-label">Longitude <sup class="text-danger">*</sup></label>
                      <input type="number" class="form-control kemis-input" id="longitude" name="longitude"
                        placeholder="Enter longitude" step="any" formControlName="longitude" />
                    </div> -->

                    <!-- Centered Button -->
                    <div class="text-center">
                      <button type="button" class="btn kemis-btn-primary mt-2" (click)="getCurrentLocation()">
                        📍 Use Current Location
                      </button>
                    </div>
                    <div class="pt-4">
                      <google-map height="300px" width="100%" [center]="center" [zoom]="zoom"
                        (mapClick)="onMapClick($event)">
                        <map-marker *ngIf="markerPosition" [position]="markerPosition" [title]="'Current Location'"
                          [options]="markerOptions"></map-marker>
                      </google-map>
                    </div>
                  </div>

                </div>

                <div class="form-actions d-flex justify-content-end">
                  <div class="d-flex gap-2">

                    <button type="button" class="btn kemis-btn-primary" id="continue-to-preview"
                      data-bs-target="#myModal" data-bs-toggle="modal" (click)="isSave=false;openPreviewModal()">
                      Preview
                    </button>

                    <button type="button" class="btn kemis-btn-primary" id="continue-to-payment" [disabled]="isSave"
                      (click)="onSubmit(instituteRegForm)">
                      Save and Continue
                      <i class="fas fa-chevron-right"></i>
                    </button>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Success Message -->
      <div class="step-content" *ngIf="currentStep === 2" id="success-content">
        <div class="row justify-content-center">
          <div class="col-lg-6">
            <div class="kemis-card text-center">
              <div class="card-body">
                <div class="success-icon">
                  <i class="fas fa-check-circle"></i>
                </div>
                <h2 class="success-title">Registration Successful!</h2>
                <p class="success-message">
                  Your institution has been successfully registered with KEMIS.
                  You will receive a confirmation email shortly.
                </p>
                <button class="btn kemis-btn-primary" onclick="location.reload()">
                  Register Another Institution
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>

  <!-- Footer -->
  <footer class="kemis-footer d-none">
    <div class="container">
      <div class="text-center">
        <p class="mb-1">
          &copy; {{ currentYear }} Ministry of Education, Republic of Kenya. All
          rights reserved.
        </p>
        <p class="mb-0">
          For technical support, contact:
          <a href="mailto:support&#64;education.go.ke">support&#64;education.go.ke</a>
        </p>
      </div>
    </div>
  </footer>
</body>

<div>
  <div class="modal" tabindex="-1" id="myModal">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Institution Registration Details</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="container">
            <fieldset class="border rounded-3 p-3">
              <legend class="float-none w-auto px-3">
                Institution Details
              </legend>
              <div class="row mb-2">
                <div class="col-md-6">
                  <strong>Name of Institution</strong> :{{
                  userDetails?.TNT_NAME}}
                </div>
                <div class="col-md-6">
                  <strong>Affiliation/University</strong>:{{ userDetails?.affiliation_University }}
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-md-6">
                  <strong>Address</strong>
                  :
                  {{userDetails?.address}}
                </div>
                <div class="col-md-6">
                  <strong>State</strong> :
                  {{ stateName }}
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-md-6">
                  <strong>Name</strong> :
                  {{ userDetails?.candidate_name }}
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-md-6">
                  <strong>Email</strong> :
                  {{ userDetails?.email }}
                </div>
                <div class="col-md-6">
                  <strong>Phone Number</strong> :
                  {{ userDetails?.mobileno }}
                </div>
              </div>

            </fieldset>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-bs-dismiss="modal">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>